import { AxiosError } from 'axios'

import ClientSDK from '../../App/ClientSDK'
import { AppDispatch } from '../../store'
import { fetchEstablishment } from '../DataStore/apiCalls'
import {
  GET_ESTABLISHMENT_FAILURE,
  GET_ESTABLISHMENT_LOADING,
  GET_ESTABLISHMENT_SUCCESS,
} from '../interface/actionTypes'
import { IEstablishment } from '../interface/IEstablishment'

const getEstablishmentSuccess = (establishment: IEstablishment) => {
  return {
    type: GET_ESTABLISHMENT_SUCCESS,
    payload: {
      establishment,
    },
  }
}

const getEstablishmentFailure = (message: string) => {
  return {
    type: GET_ESTABLISHMENT_FAILURE,
    error: true,
    payload: { error: message },
  }
}

export const getEstablishment = () => {
  return (dispatch: AppDispatch) => {
    dispatch({ type: GET_ESTABLISHMENT_LOADING })
    return fetchEstablishment()
      .then(response => dispatch(getEstablishmentSuccess(response.data)))
      .catch((error: AxiosError) => {
        ClientSDK.instance().clearTokens()
        ClientSDK.instance().refresh()

        dispatch(getEstablishmentFailure(error.message))
      })
  }
}
